var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_01_Icons_Line_log-in",
    "data-name": "01) Icons/Line/log-in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M14,16a1,1,0,1,1,0-2h1V2H14a1,1,0,1,1,0-2h2a1,1,0,0,1,1,1V15a1,1,0,0,1-1,1ZM7.611,12.819a1,1,0,0,1-.243-1.394L9.086,8.982A.778.778,0,0,1,9,9H1A1,1,0,1,1,1,7H9L7.2,4.6A1,1,0,0,1,8.8,3.4l3,4a1,1,0,0,1,.018,1.174L9,12.576a1,1,0,0,1-1.392.243Z",
    transform: "translate(0)",
    fill: "#18203a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M14,16a1,1,0,1,1,0-2h1V2H14a1,1,0,1,1,0-2h2a1,1,0,0,1,1,1V15a1,1,0,0,1-1,1ZM7.611,12.819a1,1,0,0,1-.243-1.394L9.086,8.982A.778.778,0,0,1,9,9H1A1,1,0,1,1,1,7H9L7.2,4.6A1,1,0,0,1,8.8,3.4l3,4a1,1,0,0,1,.018,1.174L9,12.576a1,1,0,0,1-1.392.243Z",
    transform: "translate(0)",
    fill: "#18203a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.07df78f9a5ebc6f916eb706863844dc3.svg";
export { ForwardRef as ReactComponent };